module.exports = __webpack_public_path__ + "Group 15706.9d5926009cd412534239.png";